<template>
  <v-card class="dialog-card">
    <!-- <div
        class="queue_name transbackground d-flex align-center justify-space-between"
        style="
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
          color: white;
          border-radius: 5px;
        ">
        <h4 class="pa-3">Delete User</h4>
        <v-spacer />
        <v-btn
          variant="text"
          class="mr-1"
          @click="emit('close')">
          <v-icon
            size="large"
            color="white">
            mdi-close-circle
          </v-icon>
        </v-btn>
      </div> -->
    <ModalHeader
      icon="mdi-account-remove"
      :modalTitle="'Delete User'"
      :modalSubtitle="'Bye bye'"
      @close="emit('close')" />

    <v-card-text>
      "{{ current_user.username }}" will be deleted, this action is
      irreversible.
    </v-card-text>
    <v-card-text>Are you sure you want to delete?</v-card-text>

    <div class="modal-footer">
      <v-spacer />
      <v-btn
        style="width: 100%; color: white"
        :loading="delete_loading"
        @click="DeleteUser()"
        color="#db655c"
        dark
        variant="flat">
        Delete User
      </v-btn>
    </div>
  </v-card>
</template>
<script setup>
import { ref, defineProps } from 'vue';
import { $http } from '../../stores/http.js';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
const emit = defineEmits(['close']);
const props = defineProps(['current_user']);
const delete_loading = ref(false);
function DeleteUser() {
  delete_loading.value = true;
  $http('DELETE', '/delete_user?username=' + props.current_user.username).then(
    () => {
      delete_loading.value = false;
      emit('close');
    }
  );
}
</script>
